<template>
  <div
    :class="$style.root"
    :data-margin-top="marginTop ? '' : null"
    :id="titleToAnhor(block?.current_locale || block?.i18n_string_en)"
  >
    {{ block?.current_locale || block?.i18n_string_en }}
    <LayoutHorizontalLineComponent />
  </div>
</template>

<script setup>
const props = defineProps({
  block: Object,
  marginTop: {
    type: Boolean,
    default: false
  }
})

const titleToAnhor = (title) => {
  return stringToAnchor(title)
}
</script>

<style module>
.root {
  composes: container--medium font-size-large from global;

  text-align: center;
  display: flex;
  flex-direction: column;
  gap: var(--unit--spacer);
}

.root[data-margin-top] {
  margin-top: var(--unit--vertical--tripple);
}
</style>
